// extracted by mini-css-extract-plugin
module.exports = {"card":"NewProject_card__kOw4_"};